/** Dev-only paste fallback (sessionStorage). Login JWT lives in localStorage via auth-shared. */
const PASTE_SESSION_KEY = 'amglobal_workspace_dev_paste_token'
/** Legacy key shared a name with localStorage login token — still read for one release. */
const LEGACY_PASTE_SESSION_KEY = 'amglobal_workspace_access_token'

/**
 * Optional `VITE_DEV_ACCESS_TOKEN` in `.env.local` (never commit).
 */
export function getDevEnvAccessToken(): string | null {
  const fromEnv = import.meta.env.VITE_DEV_ACCESS_TOKEN
  if (typeof fromEnv === 'string' && fromEnv.trim().length > 0) {
    return fromEnv.trim()
  }
  return null
}

/** JWT pasted via the workforce DevTokenBar (sessionStorage). */
export function getDevPasteAccessToken(): string | null {
  if (typeof sessionStorage === 'undefined') return null
  const raw =
    sessionStorage.getItem(PASTE_SESSION_KEY)?.trim() ||
    sessionStorage.getItem(LEGACY_PASTE_SESSION_KEY)?.trim()
  return raw ? raw : null
}

/**
 * @deprecated Prefer resolveWorkspaceAccessToken() for request auth.
 * Kept for DevTokenBar draft editing of the paste store.
 */
export function getWorkspaceAccessToken(): string | null {
  return getDevEnvAccessToken() ?? getDevPasteAccessToken()
}

export function setWorkspaceAccessToken(token: string | null): void {
  if (typeof sessionStorage === 'undefined') return
  if (!token?.trim()) sessionStorage.removeItem(PASTE_SESSION_KEY)
  else sessionStorage.setItem(PASTE_SESSION_KEY, token.trim())
}
